/**
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-raw').Options} Options
 * @typedef {import('hast-util-raw')} DoNotTouchAsThisImportIncludesRawInTree
 */
import { raw } from 'hast-util-raw';
/**
 * Plugin to parse the tree again (and raw nodes).
 * Keeping positional info OK.  🙌
 *
 * @type {import('unified').Plugin<[Options?] | void[], Root>}
 */

export default function rehypeRaw() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (tree, file) {
    // Assume that when a root was given, it’s also returned.
    var result =
    /** @type {Root} */
    raw(tree, file, options);
    return result;
  };
}